import {capitalized} from "./text";

export const SLOTS_CATEGORY = "slot";

export const isSlotsCategory = slug => ["slot", "slots"].includes((slug || "").toLowerCase());

export const SLOTS_CATEGORY_PATH = `/games/category/${SLOTS_CATEGORY}`;

/** Slots category route (production parity); carousels remain visible via isSlotsContext */
export const SLOTS_GAMES_NAVIGATION = {
  pathname: SLOTS_CATEGORY_PATH,
};

/** Route slug → [i18n key, default label] */
const CATEGORY_I18N = {
  slot: ["categorySlots", "Slots"],
  plinko: ["categoryPlinko", "Plinko"],
  poker: ["categoryPoker", "Poker"],
  fishing: ["categoryFishing", "Pesca"],
  dice: ["categoryDice", "Dados"],
  virtual_sports: ["categoryVirtualSports", "Deportes virtuales"],
};

/**
 * @param {string} slug - Category from route, e.g. "fishing", "plinko"
 * @param {Function} t - i18n translate function (games namespace)
 * @param {Array<{label: string, value: string}>} [classOptions]
 */
export const getCategoryDisplayName = (slug, t, classOptions = []) => {
  if (!slug) return "";

  const normalized = slug.toLowerCase();
  const i18n = CATEGORY_I18N[normalized];

  if (i18n) {
    return t(i18n[0], {defaultValue: i18n[1]});
  }

  const fromOptions = classOptions.find(option => option.value?.toLowerCase() === normalized);
  if (fromOptions?.label) {
    return fromOptions.label;
  }

  return capitalized(slug);
};
